export const SET_CARE_ORCH_LOADING = 'careOrchestration/SET_CARE_ORCH_LOADING';
export const SET_CARE_ORCH_ERROR = 'careOrchestration/SET_CARE_ORCH_ERROR';
export const SET_CARE_ORCH_STATS = 'careOrchestration/SET_CARE_ORCH_STATS';
export const SET_CARE_ORCH_META = 'careOrchestration/SET_CARE_ORCH_META';
export const SET_CARE_ORCH_LAST_FETCHED_AT = 'careOrchestration/SET_CARE_ORCH_LAST_FETCHED_AT';
export const SET_CARE_ORCH_CAPACITY_TASKS = 'careOrchestration/SET_CARE_ORCH_CAPACITY_TASKS';
